import React from "react";

export default function viewAccountHead() {
  return <div>viewAccountHead</div>;
}
